export class MajorExplorerUserActivityFunction {
  constructor(private majorExplorerUserActivityNameEnum: any) {}

  nameResolver(key: string, appendFirstPage: boolean) {
    return this.majorExplorerUserActivityNameEnum[`${key}${appendFirstPage ? '_PART_1' : ''}`].value.viewTitle;
  }
}

angular.module('major-explorer-data').service('majorExplorerUserActivityFn', MajorExplorerUserActivityFunction);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-major-explorer/src/data/functions/major_explorer_user_activity_fn.ts